import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { CashierEntity } from './cashier.entity'

export class CashiersRepository extends BaseRepository<CashierEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'cashiers', token, cache)
    }

    async reopen(cashierId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/cashiers/' + cashierId + '/reopen?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async close(cashierId: string, cashClose: number, cashResult: number, cashIn: number, cashOut: number, result: any[], notes?: string) {
        const { json, statusCode, message } = await this.request.post(
            this.config.posApiUrl + '/cashiers/' + cashierId + '/close?token=' + this.resolvedToken,
            { cashClose, cashResult, cashIn, cashOut, result, notes },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async opened() {
        const { json, statusCode, message } = await this.request.get(this.config.posApiUrl + '/cashiers/opened/?token=' + this.resolvedToken)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
